import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Dashboard } from '../../../dashboards/models/dashboard';

@Component({
  selector: 'mojo-dashboard-selector',
  templateUrl: './dashboard-selector.component.html'
})
export class DashboardSelectorComponent implements OnInit {
  @Input()
  dashboards: Dashboard[];
  @Input()
  selectedDashboard: Dashboard;

  @Output()
  onChange = new EventEmitter<Dashboard>();

  mappedDashboards: SelectItem[];

  ngOnInit(): void { }

  ngOnChanges(): void {
    this.mappedDashboards = this.dashboards
      ? this.dashboards.map(p => ({ label: p.Label, value: p }))
      : [];
    // Angular 17 upgrade - PrimeNG have deprecated autoDisplayFirst
    if (!this.selectedDashboard && this.dashboards?.length) {
      this.selectedDashboard = this.dashboards[0]
    }
  }

  bubbleOnChange(event): void {
    const dashboard: Dashboard = event.value;
    this.onChange.emit(dashboard);
  }

}
